import { withNavigationWatcher } from "./contexts/navigation";
import { ProductPage } from "./pages";
import AccountPage from "./pages/account";
import AccountDetailPage from "./pages/account/detail";
import { CallLogs } from "./pages/call-logs";
import CreateAccountProductForm from "./pages/account/detail/tabs/product/create";
import { AccountCalls } from "./pages/callStatus";
import CategoryPage from "./pages/category";
import ContractPage from "./pages/contracts";
import Dashboard from "./pages/dashboard";
import NotificationPage from "./pages/Notification";
import ProductRequestPage from "./pages/productRequestPage";
import ProductDetailPage from "./pages/products/detail";
import Profile from "./pages/profile/profile";
import Slider from "./pages/slider";
import TicketManagement from "./pages/TicketManagement";
import BlogPage from "./pages/blog";
import PoliciesPage from "./pages/policies";
import SSSPage from "./pages/SSS";
import ProductFetures from "./pages/productFeatures";
import EmailTemplatePage from "./pages/emailTemplate";
import Contact from "./pages/contact";
import AdminPackagesPage from "./pages/packages";
import SystemPackagePricePage from "./pages/systemPrice";

const routes = [
  {
    path: "/",
    component: Dashboard,
  },
  {
    path: "/profile",
    component: Profile,
  },
  {
    path: "/account",
    component: AccountPage,
  },
  {
    path: "/account-details/:Id",
    component: AccountDetailPage,
  },
  {
    path: "/product",
    component: ProductPage,
  },
  {
    path: "/product-details/:Id",
    component: ProductDetailPage,
  },
  {
    path: "/product-requests",
    component: ProductRequestPage,
  },
  {
    path: "/tickets",
    component: TicketManagement,
  },
  {
    path: "/contracts",
    component: ContractPage,
  },
  {
    path: "/add-account-product/:Id",
    component: CreateAccountProductForm
  },
  {
    path: "/notifications",
    component: NotificationPage
  },
  {
    path: "/sliders",
    component: Slider
  },
  {
    path: "/categories",
    component: CategoryPage
  },
  {
    path: "/call-status",
    component: AccountCalls,
  },
  {
    path: "/call",
    component: CallLogs,
  },
  {
    path: "/blogs",
    component: BlogPage
  },
  {
    path: "/policies",
    component: PoliciesPage
  },
  {
    path: "/sss",
    component: SSSPage
  },
  {
    path: "/productFeatures",
    component: ProductFetures
  },
  {
    path: "/emailTemplate",
    component: EmailTemplatePage
  },
  {
    path: "/contacts",
    component: Contact
  },
  {
    path: "/packages",
    component: AdminPackagesPage
  },
  {
    path: "/system-price",
    component: SystemPackagePricePage
  }
];

export default routes.map((route) => {
  return {
    ...route,
    component: withNavigationWatcher(route.component),
  };
});
